import {
    FeatureTogglesState,
    initialFeatureTogglesState,
} from './FeatureTogglesState';
import {
    FeatureToggleStateAction,
    FeatureToggleStateActionType,
} from './actions';
import { Reducer } from 'redux';

export const featureTogglesStateReducer: Reducer<
    FeatureTogglesState,
    FeatureToggleStateAction
> = (state = initialFeatureTogglesState, action) => {
    switch (action.type) {
        case FeatureToggleStateActionType.SET: {
            return action.payload!;
        }
        case FeatureToggleStateActionType.TOGGLE: {
            return {
                ...state,
                [action.payload!.feature]: !state[action.payload!.feature],
            };
        }
    }
    return state;
};
